"use strict";
var $ = require("../internals/export");
var numberIsFinite = require("../internals/number-is-finite");
$({ target: "Number", stat: true }, { isFinite: numberIsFinite });
